import { isDesignMode } from 'src/config/designMode'
import { getTenant } from 'src/config/tenant'

const PRESIGNED_URL_API = process.env.REACT_APP_PRESIGNED_URL_API!

interface PresignedUrlResponse {
    url: string
    key: string
}

export const getPresignedUrl = async (
    type: 'positions' | 'movements',
    filename: string,
    cognitoIdToken: string
): Promise<PresignedUrlResponse> => {
    if (isDesignMode) {
        return { url: 'https://design-mode-mock', key: `${type}/${filename}` }
    }

    const tenant = getTenant()
    const params = new URLSearchParams({ type, filename })
    const response = await fetch(`${PRESIGNED_URL_API}/${tenant}/presigned-url?${params}`, {
        headers: {
            Authorization: `Bearer ${cognitoIdToken}`,
        },
    })
    if (!response.ok) {
        throw new Error(`Erro ao obter URL de upload: ${response.status}`)
    }
    return response.json()
}

export const uploadToS3 = async (presignedUrl: string, file: File): Promise<void> => {
    if (isDesignMode) return

    const response = await fetch(presignedUrl, {
        method: 'PUT',
        headers: {
            'Content-Type': file.type || 'application/octet-stream',
        },
        body: file,
    })
    if (!response.ok) {
        throw new Error(`Erro ao enviar arquivo: ${response.status}`)
    }
}